import { actions } from '../actions/usuarioActions'

const initialState = {
	currentUser: null,
	proyectos: []
}

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actions.setCurrentUser:
			return {
				...state,
				currentUser: action.payload
			}
		case actions.setProyectos:
			return {
				...state,
				proyectos: action.payload
			}
		default:
			return state;
	}
}

export default reducer